import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Radio, { RadioGroup } from "material-ui/Radio";

import { FormControl, FormControlLabel, FormLabel } from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "../new/styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

class TestSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      fiber: false,
      copper: false,
      next: true,
      jobType: this.props.jobType,
      coax: false,
      coax: false
    };
  }

  onChange = e => {
    let currentSelection = e.target.value;
    const { fiber, copper, coax, jobType } = this.state;

    if (currentSelection === "fiber") {
      this.setState({
        fiber: true,
        copper: false,
        coax: false,
        next: false
      });
    } else if (currentSelection === "copper") {
      this.setState({
        fiber: false,
        copper: true,
        coax: false,
        next: false
      });
    } else {
      this.setState({
        fiber: false,
        copper: false,
        coax: true,
        next: false
      });
    }
  };

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel("cancel", "testSelection");
  };

  selectedTest = () => {
    const { testSelection } = this.props;
    const { fiber, copper, coax } = this.state;
    testSelection(fiber, copper, coax);
  };

  render() {
    const { classes, translate } = this.props;

    const { fiber, copper, coax, next, jobType } = this.state;

    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <FormLabel component="legend">
                {jobType == "Signaltek"
                  ? translate("test_types_signaltek")
                  : translate("test_types")}
              </FormLabel>
              <RadioGroup
                aria-label="testSelection"
                name="cableshielding"
                className={classes.group}
                onChange={this.onChange}
              >
                <FormControlLabel
                  value="fiber"
                  control={<Radio checked={fiber} />}
                  label={
                    jobType == "Signaltek"
                      ? translate("create_signaltek_fiber")
                      : translate("create_comet_fiber")
                  }
                />
                <FormControlLabel
                  value="copper"
                  control={<Radio checked={copper} />}
                  label={
                    jobType == "Signaltek"
                      ? translate("create_signaltek_copper")
                      : translate("comet_copper")
                  }
                />
                {jobType != "Signaltek" && (
                  <FormControlLabel
                    value="coax"
                    control={<Radio checked={coax} />}
                    label={translate("create_comet_coax")}
                  />
                )}
              </RadioGroup>
            </ModalContents>
            <ModalFooter>
              <Button
                raised
                color="accent"
                className={classes.submit}
                onClick={() => this.selectedTest()}
                type="submit"
                disabled={next}
              >
                <Icon>navigate_next</Icon>
              </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(TestSelection);



// WEBPACK FOOTER //
// ./src/components/job/testselection/index.js